/* Simpatico V2 product rails: tabs, arrow buttons, GA4 list events.
   Safe to load more than once (each section initialises itself once). */
(function () {
  'use strict';

  function visibleRail(root) {
    var panels = root.querySelectorAll('.s2-rails__panel');
    for (var i = 0; i < panels.length; i++) {
      if (!panels[i].hidden) return panels[i].querySelector('[data-rail]');
    }
    return root.querySelector('[data-rail]');
  }

  function syncArrows(root) {
    var rail = visibleRail(root);
    var prev = root.querySelector('[data-rail-prev]');
    var next = root.querySelector('[data-rail-next]');
    if (!rail || !prev || !next) return;
    var max = rail.scrollWidth - rail.clientWidth - 2;
    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft >= max;
    var hide = rail.scrollWidth <= rail.clientWidth + 2;
    prev.parentElement.style.visibility = hide ? 'hidden' : '';
  }

  function gtagEvent(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
  }

  function itemFrom(card) {
    return {
      item_id: card.getAttribute('data-product-id'),
      item_name: card.getAttribute('data-product-title'),
      item_brand: card.getAttribute('data-product-vendor'),
      price: parseFloat(card.getAttribute('data-product-price')) || undefined,
      index: parseInt(card.getAttribute('data-position'), 10) || undefined
    };
  }

  function reportView(rail) {
    if (!rail || rail.__s2Viewed) return;
    rail.__s2Viewed = true;
    var cards = rail.querySelectorAll('.s2-pcard');
    if (!cards.length) return;
    var list = cards[0].getAttribute('data-list') || 'Homepage rail';
    var items = [];
    for (var i = 0; i < cards.length && i < 12; i++) items.push(itemFrom(cards[i]));
    gtagEvent('view_item_list', { item_list_name: list, items: items });
  }

  function init(root) {
    if (root.__s2RailsReady) return;
    root.__s2RailsReady = true;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    tabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function () { select(idx, false); });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var to = (idx + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
        select(to, true);
      });
    });

    function select(idx, focus) {
      tabs.forEach(function (t, i) {
        var on = i === idx;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tabs[idx].focus();
      var rail = visibleRail(root);
      if (rail) rail.scrollLeft = 0;
      syncArrows(root);
      reportView(rail);
    }

    var prev = root.querySelector('[data-rail-prev]');
    var next = root.querySelector('[data-rail-next]');
    function page(dir) {
      var rail = visibleRail(root);
      if (!rail) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      rail.scrollBy({ left: dir * rail.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      setTimeout(function () { syncArrows(root); }, 450);
    }
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    root.querySelectorAll('[data-rail]').forEach(function (rail) {
      rail.addEventListener('scroll', function () { syncArrows(root); }, { passive: true });
    });
    window.addEventListener('resize', function () { syncArrows(root); });

    root.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('.s2-pcard');
      if (!card) return;
      gtagEvent('select_item', {
        item_list_name: card.getAttribute('data-list') || 'Homepage rail',
        items: [itemFrom(card)]
      });
    });

    syncArrows(root);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { reportView(visibleRail(root)); io.disconnect(); }
        });
      }, { threshold: 0.4 });
      io.observe(root);
    }
  }

  function boot() {
    document.querySelectorAll('[data-s2-rails]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
